import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { IMTab } from './typings';

@Component({
  selector: 'm-card-body-container',
  exportAs: 'mCardBodyContainer',
  template: `
    <div class="m-card-body-container">
      <ng-content select="m-page-banner"></ng-content>
      <nz-tabset
        class="m-card-body-tabset"
        [nzTabBarExtraContent]="extraTemplate"
        [nzSelectedIndex]="mSelectedIndex"
        (nzSelectedIndexChange)="selectedIndex($event)"
      >
        <nz-tab *ngFor="let tab of mTabs" [nzTitle]="mShowTabIcon ? titleTemplate : tab.name">
          <ng-template #titleTemplate>
            <i nz-icon *ngIf="tab.icon" class="m-card-body-tab-icon" nz-tooltip [nzTooltipTitle]="tab.tooltipText" [nzType]="tab.icon"></i>
            {{ tab.name }}
          </ng-template>
          <ng-template *ngIf="mCardTabRef" [ngTemplateOutlet]="mCardTabRef"></ng-template>
          <div class="m-card-body-content-container">
            <ng-template *ngIf="mContentRef" [ngTemplateOutlet]="mContentRef"></ng-template>
          </div>
        </nz-tab>
      </nz-tabset>
      <ng-template #extraTemplate>
        <ng-template *ngIf="mHeaderRef" [ngTemplateOutlet]="mHeaderRef"></ng-template>
      </ng-template>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class MCardBodyContainerComponent {
  @Input() mHeaderRef?: TemplateRef<void>;
  @Input() mContentRef?: TemplateRef<void>;
  @Input() mCardTabRef?: TemplateRef<void>;
  @Input() mTabs: IMTab[] = [];
  @Input() mShowTabIcon: boolean = false;
  @Input() mSelectedIndex: number = 0;

  @Output() readonly mSelectedIndexChange = new EventEmitter<number>();

  selectedIndex(value: number): void {
    this.mSelectedIndexChange.emit(value);
  }
}
